/**
 * @param {{ inStorePickupEligibility: boolean, curbsidePickupEligibility: boolean, availabilityMessage: string }} param0
 * @returns {string}
 */
export const bossPickupMessagging = ({ inStorePickupEligibility = false, curbsidePickupEligibility = false, availabilityMessage = 'NA' }) => {
  let fireLinkTagMessage = '';
  // check In Store and Curbside eligibility to determine boss messaging
  switch (true) {
    case inStorePickupEligibility === true && curbsidePickupEligibility === true:
      fireLinkTagMessage = `In Store:${availabilityMessage}-Curbside:${availabilityMessage}`;
      break;
    case inStorePickupEligibility === true && curbsidePickupEligibility === false:
      fireLinkTagMessage = `In Store:${availabilityMessage}-Curbside:NA`;
      break;
    case inStorePickupEligibility === false && curbsidePickupEligibility === true:
      fireLinkTagMessage = `In Store:NA-Curbside:${availabilityMessage}`;
      break;
    default:
      fireLinkTagMessage = 'In Store:NA-Curbside:NA';
      break;
  }
  return fireLinkTagMessage;
};
